import { LOCALE } from './activity-constants'

// PARA CANJEA SIN TILDE ESTOS PAISES
const canjea = ['es-PE', 'es-CL'].includes(LOCALE)
// PARA CANJEÁ CON TILDE ESTOS PAISES
const canje_a = ['es-AR', 'es-PY', 'es-UY'].includes(LOCALE)

export const $Redimir = canjea || canje_a ? 'Canjear' : 'Redimir'
export const $redimir = canjea || canje_a ? 'canjear' : 'redimir'
export const $Redime = canje_a ? 'Canjeá' : canjea ? 'Canjea' : 'Redime'
export const $redime = canje_a ? 'canjeá' : canjea ? 'canjea' : 'redime'

//Cambio de palabra pena por vergüenza
const verguenza = ['es-CL', 'es-PR', 'es-DO'].includes(LOCALE)

// GLOSARIO ARGENTINIZADO
const argen = ['es-AR', 'es-PY', 'es-UY'].includes(LOCALE)
export const WORDS = {
  Activa: argen ? 'Activá' : 'Activa',
  acompañame: argen ? 'acompañame' : 'acompáñame',
  acumula: argen ? 'acumulá' : 'acumula',
  Acumula: argen ? 'Acumulá' : 'Acumula',
  Ayudanos: argen ? 'Ayudanos' : 'Ayúdanos',
  Ayudame: argen ? 'Ayudame' : 'Ayúdame',
  Ayuda: argen ? 'Ayudá' : 'Ayuda',
  arma: argen ? 'armá' : 'arma',
  Arma: argen ? 'Armá' : 'Arma',
  aqui: argen ? 'acá' : 'aquí',
  Aqui: argen ? 'Acá' : 'Aquí',
  avanza: argen ? 'avanzá' : 'avanza',
  Atrapa: argen ? 'Atrapá' : 'Atrapa',
  atrapes: argen ? 'atrapés' : 'atrapes',
  atrapas: argen ? 'atrapás' : 'atrapas',
  atrevete: argen ? 'atrevete' : 'atrévete',
  Atrevete: argen ? 'Atrevete' : 'Atrévete',
  Aprende: argen ? 'Aprendé' : 'Aprende',
  avances: argen ? 'avancés' : 'avances',
  Avances: argen ? 'Avancés' : 'Avances',
  Busca: argen ? 'Buscá' : 'Busca',
  cojas: argen ? 'atrapes' : 'cojas',
  Completa: argen ? 'Completá' : 'Completa',
  completa: argen ? 'completá' : 'completa',
  completas: argen ? 'completás' : 'completas',
  Completas: argen ? 'Completás' : 'Completas',
  conocelas: argen ? 'conocelas' : 'conócelas',
  Conocelas: argen ? 'Conocelas' : 'Conócelas',
  Continua: argen ? 'Continuá' : 'Continúa',
  Comparte: argen ? 'Compartí' : 'Comparte',
  Comienza: argen ? 'Comenzá' : 'Comienza',
  Cuentanos: argen ? 'Contanos' : 'Cuéntanos',
  crea: argen ? 'creá' : 'crea',
  Crea: argen ? 'Creá' : 'Crea',
  da: argen ? 'hacé' : 'da',
  debes: argen ? 'debés' : 'debes',
  Debes: argen ? 'Debés' : 'Debes',
  dejes: argen ? 'dejés' : 'dejes',
  duermes: argen ? 'dormís' : 'duermes',
  descubre: argen ? 'descubrí' : 'descubre',
  Descubrelo: argen ? 'Descubrilo' : 'Descúbrelo',
  Descargalo: argen ? 'Descargalo' : 'Descárgalo',
  derribes: argen ? 'derribés' : 'derribes',
  derriba: argen ? 'derribá' : 'derriba',
  demores: argen ? 'demorés' : 'demores',
  detengas: argen ? 'detengás' : 'detengas',
  Deseas: argen ? 'Deseás' : 'Deseas',
  demuestra: argen ? 'demuestrá' : 'demuestra',
  Demuestra: argen ? 'Demuestrá' : 'Demuestra',
  Diviertete: argen ? 'Divertite' : 'Diviértete',
  diviertete: argen ? 'divertite' : 'diviértete',
  diviertas: argen ? 'divirtás' : 'diviertas',
  entregalos: argen ? 'entregálos' : 'entrégalos',
  Eres: argen ? 'Sos' : 'Eres',
  eres: argen ? 'sos' : 'eres',
  Escoge: argen ? 'Escogé' : 'Escoge',
  Escojas: argen ? 'Escojás' : 'Escojas',
  escojas: argen ? 'escojás' : 'escojas',
  Escapa: argen ? 'Escapá' : 'Escapa',
  elige: argen ? 'elegí' : 'elige',
  Elige: argen ? 'Elegí' : 'Elige',
  elijas: argen ? 'elijás' : 'elijas',
  Evita: argen ? 'Evitá' : 'Evita',
  empieces: argen ? 'empecés' : 'empieces',
  formas: argen ? 'formás' : 'formas',
  gana: argen ? 'ganá' : 'gana',
  Gana: argen ? 'Ganá' : 'Gana',
  ganas: argen ? 'ganás' : 'ganas',
  Ganas: argen ? 'Ganás' : 'Ganas',
  ganes: argen ? 'ganés' : 'ganes',
  ganaras: argen ? 'ganás' : 'ganarás',
  Gira: argen ? 'Girá' : 'Gira',
  Guarda: argen ? 'Guardá' : 'Guarda',
  Haz: argen ? 'Hacé' : 'Haz',
  haces: argen ? 'sos' : 'haces',
  inicia_sesion: argen ? 'Iniciá sesión' : 'Inicia sesión',
  inscribe: argen ? 'inscribí' : 'inscribe',
  Inscribe: argen ? 'Inscribí' : 'Inscribe',
  ingresa: argen ? 'ingresá' : 'ingresa',
  Ingresa: argen ? 'Ingresá' : 'Ingresa',
  juega: argen ? 'Jugá' : 'Juega',
  Juega: argen ? 'Jugá' : 'Juega',
  manches: argen ? 'manchés' : 'manches',
  Mira: argen ? 'Mirá' : 'Mira',
  menstrues: argen ? 'menstrues' : 'menstrúes',
  memoriza: argen ? 'memorizá' : 'memoriza',
  Memoriza: argen ? 'Memorizá' : 'Memoriza',
  Muevete: argen ? 'Movete' : 'Muévete',
  logras: argen ? 'lográs' : 'logras',
  logres: argen ? 'logrés' : 'logres',
  Llega: argen ? 'Llegá' : 'Llega',
  olvides: argen ? 'olvidés' : 'olvides',
  oprimas: argen ? 'oprimás' : 'oprimas',
  tienes: argen ? 'tenés' : 'tienes',
  Tienes: argen ? 'Ténes' : 'Tienes',
  invítalas: argen ? 'invitalas' : 'invítalas',
  ti: argen ? 'vos' : 'ti',
  juntas: argen ? 'juntás' : 'juntas',
  pases: argen ? 'pasés' : 'pases',
  preocupes: argen ? 'preocupés' : 'preocupes',
  recolecta: argen ? 'recolectá' : 'recolecta',
  Redime: $Redime,
  redime: $redime,
  Redimir: $Redimir,
  redimir: $redimir,
  Redimes: canje_a ? 'Canjeás' : canjea ? 'Canjeas' : 'Redimes',
  redimes: canje_a ? 'canjeás' : canjea ? 'canjeas' : 'redimes',
  redimiendo: canjea || canje_a ? 'canjeando' : 'redimiendo',
  Recuerda: argen ? 'Recordá' : 'Recuerda',
  responde: argen ? 'respondé' : 'responde',
  Responde: argen ? 'Respondé' : 'Responde',
  respondes: argen ? 'respondés' : 'respondes',
  Respondes: argen ? 'Respondés' : 'Respondes',
  Recogelos: argen ? 'Recogelos' : 'Recógelos',
  Recoge: argen ? 'Recogé' : 'Recoge',
  Revela: argen ? 'Revelá' : 'Revela',
  registrate: argen ? 'registrate' : 'regístrate',
  rindas: argen ? 'rindás' : 'rindas',
  revisa: argen ? 'revisá' : 'revisa',
  Revisa: argen ? 'Revisá' : 'Revisa',
  Pasa: argen ? 'Pasá' : 'Pasa',
  permitas: argen ? 'permitás' : 'permitas',
  Presiona: argen ? 'Presioná' : 'Presiona',
  pierdas: argen ? 'perdás' : 'pierdas',
  pon: argen ? 'poné' : 'pon',
  Pon: argen ? 'Poné' : 'Pon',
  podras: argen ? 'podés' : 'podrás',
  puedes: argen ? 'podés' : 'puedes',
  Puedes: argen ? 'Podés' : 'Puedes',
  puedas: argen ? 'podás' : 'puedas',
  Pulsa: argen ? 'Pulsá' : 'Pulsa',
  quieres: argen ? 'querés' : 'quieres',
  quieras: argen ? 'querás' : 'quieras',
  Quieres: argen ? 'Querés' : 'Quieres',
  Salta: argen ? 'Saltá' : 'Salta',
  selecciona: argen ? 'seleccioná' : 'selecciona',
  Selecciona: argen ? 'Seleccioná' : 'Selecciona',
  sigue: argen ? 'seguí' : 'sigue',
  Sigue: argen ? 'Seguí' : 'Sigue',
  sigas: argen ? 'sigás' : 'sigas',
  sumergete: argen ? 'sumergite' : 'sumérgete',
  superes: argen ? 'superés' : 'superes',
  Ten: argen ? 'Tené' : 'Ten',
  usa: argen ? 'usá' : 'usa',
  Usa: argen ? 'Usá' : 'Usa',
  vayas: argen ? 'vayás' : 'vayas',
  Vayas: argen ? 'Vayás' : 'Vayas',
  verguenza: verguenza ? 'vergüenza' : 'pena',
  vuelvas: argen ? 'volvás' : 'vuelvas',
  Vuelve: argen ? 'Volve' : 'Vuelve',
  quedas: argen ? 'quedás' : 'quedas',
  Quedas: argen ? 'Quedás' : 'Quedas',
}
